import { DataBean } from "../DataBean";

export class Proof extends DataBean {

  public async getDisabilityCodesCatalogPorPropiedades(properties: any,maxRows: number): Promise<any> {
    return this.getCustomService("TalentERP","java.util.List_getDisabilityCodesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

}
